import type { FaireProductEntity } from "../../entity_types/product";

export const p_cduuk3etfq: FaireProductEntity = {
  token: "p_cduuk3etfq",
  type: "product",
  name: "Crystal Rectangle Semi Precious Earrings",
  brandToken: "b_y2j497tv82",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8bf49b62faeb1c5cd018895c3eae70e8a39431f52b4768546df6515080c2bb52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55e7ae597384cc9cfe0d9fd279a725f9e6a9f2fef1ee96402eed35603d64c316.jpeg",
    "https://cdn.faire.com/fastly/264fe7205b48ab2201c3c1502e25b26905e87820a89b1117f0344e2a1af0cf78.jpeg",
  ],
  priceDollars: 4.99,
  description:
    "Green and Purple Crystal\n\nGold plated\n\nHandmade\n\nEarring size 2CM * 6CM\n\nCrystal and alloy material",
  tags: [],
  msrpDollars: 9.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:21.385Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
